<template>
  <div>
    <!-- toasts message -->
    <Snackbar :SnackbarVal="SnackbarVal" ref="loader"></Snackbar>
    <!-- /toasts message -->

    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="dialog2" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="dialog2 = false">Disagree</v-btn>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmDelete(row_index, delete_id)"
            >Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->

    <!-- {{formSchema}} -->
    <v-form v-model="valid" ref="form" lazy-validation>
      <v-card-text class="pb-0">
        <v-container grid-list-md class="pb-0">
          <v-flex xs12 sm12 md12>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12>
                <v-select
                  label="StakeHolder"
                  item-text="dev_partner_name"
                  item-value="id"
                  v-model="devMt_partner_id"
                  :items="devMtPartnerList"
                  :rules="[v => !!v || 'Department partner is required !']"
                  required
                ></v-select>
              </v-flex>
            </v-layout>

            <v-layout row wrap v-if="creditMasterList.length<1">
              <v-flex xs12 sm12 md12>
                <v-alert
                :value="true"
                type="warning"
                >
                First of all you need to add credit master information
              </v-alert>
              </v-flex>
            </v-layout>

            <v-layout row wrap v-for="(val,i) in creditMasterList" :key="i">
              <v-flex xs12 sm12 md2>
                <div class="tableTd">
                  <v-checkbox
                    v-model="formSchema[i].credit_id"
                    :value="val.id"
                    v-on:click.native="activeCheckBox(i)"
                  ></v-checkbox>
                </div>
                <div class="tableTd">{{val.credit_name}} &nbsp;&nbsp;</div>
              </v-flex>

              <v-flex xs12 sm12 md5 v-if="formSchema[i].credit_id">
                <v-text-field
                  :readonly="formSchema[i].credit_id<1"
                  label="Amount (USD)(Million)"
                  v-model="formSchema[i].credit_amount_usd"
                  :rules="rules.decimalOnly"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md5 v-if="formSchema[i].credit_id">
                <v-text-field
                  :readonly="formSchema[i].credit_id<1"
                  label="Amount (TK)(Lac)"
                  v-model="formSchema[i].credit_amount_tk"
                  :rules="rules.decimalOnly"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-container>
      </v-card-text>
    </v-form>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="error" @click="previous">
        <v-icon>arrow_back_ios</v-icon>Previous
      </v-btn>

      <template v-if="revision>0">
        <v-btn color="primary" @click="submitOperationActivities">
          <v-icon>rate_review</v-icon>Revision
        </v-btn>
      </template>

      <template v-else>
        <v-btn v-if="creditMasterList.length>0" color="success" @click="submitOperationActivities">
          <v-icon>save</v-icon> Save          
        </v-btn>               
      </template>
      <v-btn v-if="formSchema.length>0 && formSchema[0].id>0" color="primary" @click="nextStep">
          Next <v-icon>arrow_forward_ios</v-icon>
        </v-btn> 
    </v-card-actions>
  </div>
</template>

<script>
let commonService = require("../../../../services/common.service");
export default {
  data() {
    return {
      valid: true,

      devMt_partner_id: "",
      operation_act_id: "",
      e1: 0,
      credit: "",
      revision: null,

      rules: {
        decimalOnly: [
          v => !!v || "Field is required",
          v => /^\d+(\.\d)?\d*$/.test(v) || "Enter number only"
        ]
      },
      delete_id: "",
      row_index: "",
      dialog2: false,

      SnackbarVal: {
        snackbar: false,
        color: "success",
        message: ""
      },

      devMtPartnerList: [],
      creditMasterList: [],
      formSchema: [
        {
          id: 0,
          ope_act_id: sessionStorage.getItem("operation_act_id"),
          credit_id: "",
          devMt_partner_id: "",
          credit_amount_usd: "",
          credit_amount_tk: ""
        }
      ],

      dataList: []
    };
  },

  created() {
    this.revision = sessionStorage.getItem("revision");

    let $this = this;
    let operation_actId = sessionStorage.getItem("operation_act_id");

    commonService.getAllData("get-dropdown-data").then(res => {

      $this.devMtPartnerList = res.DevelopmentPartner;      
      $this.formSchema = [];
      for (let i = 0; i < res.CreditMaster.length; i++) {
        $this.formSchema.push({
          id: 0,
          ope_act_id: operation_actId,
          credit_id: "",
          devMt_partner_id: "",
          credit_amount_usd: "",
          credit_amount_tk: ""
        });
      }

      $this.creditMasterList = res.CreditMaster;

      if (operation_actId) {
        $this.loadData(operation_actId);
      } else {
        console.log("this.operation_act_id is empty");
      }
    });
  },

  mounted() {
    this.operation_act_id = sessionStorage.getItem("operation_act_id");
  },

  methods: {
    loadData(opId) {
      let root = this;
      commonService
        .getAllDataById(opId, "operation-act-development-partner-list")
        .then(res => {
          if (res.data.length > 0) {
            root.dataList = res.data;
            root.devMt_partner_id = res.data[0].devMt_partner_id;

            res.data.forEach(function(val,key){
              root.formSchema[key] = val;
            });            
          }
        });
    },

    activeCheckBox(index) {
      var active = this.formSchema[index].credit_id;
    },

    submitOperationActivities() {
      if (this.$refs.form.validate()) {
        let formSchema = this.formSchema;
        this.submitForm();
      }
    },

    submitForm() {

      let formSchema = this.formSchema;
      formSchema[0].devMt_partner_id = this.devMt_partner_id;

      formSchema[0].revision = this.revision > 0 ? this.revision : null;
      
      this.$refs.loader.loaderEnabled();

      let root = this;
      commonService
        .insertFormData(this.formSchema, "operation-act-development-prt")
        .then(res => {
          if (res.status == 1) {
            this.dataList = res.data;
            this.formSchema = res.data;
            this.SnackbarVal.color = "success";
          }
          else
          {
            this.SnackbarVal.color = "error"; 
          }
          this.SnackbarVal.message = res.message;
          this.SnackbarVal.snackbar = true;

        });
    },

    getName: function(partnerId) {
      if (partnerId) {
        return this.devMtPartnerList.filter(function(a) {
          return a.id == partnerId;
        })[0].dev_partner_name;
      }
    },

    nextStep() {
      this.$emit("emitForm3", 3);
    },

    previous() {
      this.$emit("emitForm3", 1);
    },

    editItem(index, item) {
      this.row_index = index;
      this.formSchema = item;
      window.scrollTo({
        top: 0,
        left: 100,
        behavior: "smooth"
      });
    },

    deleteItem(index, id) {
      this.row_index = index;
      this.delete_id = id;
      this.dialog2 = true;
    },

    confirmDelete(row_index, id) {
      commonService.deleteRow(id, "operation-act-development-prt").then(res => {
        if (res.status == 1) {
          this.dataList.splice(row_index, 1);
          this.SnackbarVal.color = "success";
        }
        else
        {
          this.SnackbarVal.color = "error"; 
        }
        this.SnackbarVal.message = res.message;
        this.SnackbarVal.snackbar = true;

        this.confirmModel = false;
        this.dialog2 = false;
      });
    },

    close: function() {
      // let formSchema = this.formSchema;
      // Object.keys(formSchema).forEach(function(key) {
      //   formSchema[key] = "";
      // });
      //this.$refs.form.reset();
    }
  }
};
</script>

<style scoped>
.tableTd {
  display: inline-block;
}
</style>


// WEBPACK FOOTER //
// src/components/project_info/operation_activities/step_forms/developmentPartner.vue